export const CompensationEquityReport = () => {
  return <>Compensation Equity Report</>;
};
